import { Notyf } from "notyf";

function uploadFile(file) {
  let url = "/marks"
  let formData = new FormData()

  formData.append("mark[file]", file);
  const metaCsrf = document.querySelector("meta[name='csrf-token']");
  const csrfToken = metaCsrf.getAttribute("content");

  const metaContext = document.querySelector("meta[name='marks-context']");
  const context = JSON.parse(metaContext.getAttribute("content"));

  if (context && context.tags) {
    formData.append("mark[tag_list]", context.tags.join(" "));
  }

  fetch(url, {
    method: "POST",
    body: formData,
    headers: {
      "x-csrf-token": csrfToken,
    },
  })
  .then(() => {
    const notyf = new Notyf({
      ripple: false,
      position: {
        x: 'center',
        y: 'top'
      }
    });
    notyf.success("Uploaded.");
  })
  .catch((e) => {
    const notyf = new Notyf({
      ripple: false,
      position: {
        x: 'center',
        y: 'top'
      }
    });
    notyf.error("Error uploading...");
  })
}

function handleFiles(files) {
  ([...files]).forEach(uploadFile)
}

function handleDrop(event, tags){
  console.log(`File(s) dropped`);

  // Prevent default behavior (Prevent file from being opened)
  event.preventDefault();

  console.log(event);

  let dt = event.dataTransfer;
  let files = dt.files;

  handleFiles(files);
}

function handleDragOver(event) {
  // Prevent default behavior (Prevent file from being opened)
  event.preventDefault();
}

window.handleDrop = handleDrop;
window.handleDragOver = handleDragOver;
